<script setup>

const emit = defineEmits(['changeMode'])
defineProps({
    mode: Number
})
</script>

<template>
    <div>
            <span class="pa-3 mode-control" @click="emit('changeMode', 1)">
                <svg width="16" height="10" :class="mode === 1 ? 'active' : ''">
                    <rect x="0" y="0" width="4" height="4"/>
                    <rect x="6" y="0" width="10" height="4"/>
                    <rect x="0" y="6" width="4" height="4"/>
                    <rect x="6" y="6" width="10" height="4"/>
                </svg>
            </span>
        <span class="pa-3 mode-control" @click="emit('changeMode', 2)">
                <svg width="10" height="10" :class="mode === 2 ? 'active' : ''">
                    <rect x="0" y="0" width="4" height="4"/>
                    <rect x="6" y="0" width="4" height="4"/>
                    <rect x="0" y="6" width="4" height="4"/>
                    <rect x="6" y="6" width="4" height="4"/>
                </svg>
            </span>
        <span class="pa-3 mode-control" @click="emit('changeMode', 3)">
                <svg width="16" height="10" :class="mode === 3 ? 'active' : ''">
                    <rect x="0" y="0" width="4" height="4"/>
                    <rect x="6" y="0" width="4" height="4"/>
                    <rect x="12" y="0" width="4" height="4"/>
                    <rect x="0" y="6" width="4" height="4"/>
                    <rect x="6" y="6" width="4" height="4"/>
                    <rect x="12" y="6" width="4" height="4"/>
                </svg>
            </span>
        <span class="pa-3 mode-control" @click="emit('changeMode', 4)">
                <svg width="22" height="10" :class="mode === 4 ? 'active' : ''">
                    <rect x="0" y="0" width="4" height="4"/>
                    <rect x="6" y="0" width="4" height="4"/>
                    <rect x="12" y="0" width="4" height="4"/>
                    <rect x="18" y="0" width="4" height="4"/>
                    <rect x="0" y="6" width="4" height="4"/>
                    <rect x="6" y="6" width="4" height="4"/>
                    <rect x="12" y="6" width="4" height="4"/>
                    <rect x="18" y="6" width="4" height="4"/>
                </svg>
            </span>
    </div>
</template>

<style scoped lang="scss">
@use 'vuetify/lib/styles/settings/colors' as *;
@use 'sass:map';

.mode-control {
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    &:hover, &:focus {
        svg {
            fill: black;
        }
    }
}

svg {
    transition: fill .3s ease;
    cursor: pointer;
    fill: map.get($grey, lighten-2);

    &.active {
        fill: black;
    }
}
</style>
